<app-page-container 
  [DataTableSchema]="dataTableSchema" [title]="title" [dynamicFormArray]="filterSchema" 
  [props]="props" [layoutType]="LayoutType.List">
</app-page-container>